import React, { PropsWithChildren, useContext } from 'react';
import { useSelector } from '@xstate/react';
import { HatcheningContext } from './context';
import { HatcheningState } from './state-machine';

export function HatcheningStep({
  children,
  steps,
}: PropsWithChildren<{ steps: HatcheningState | HatcheningState[] }>) {
  const ctx = useContext(HatcheningContext);
  const validSteps = Array.isArray(steps) ? steps : [steps];
  const render = useSelector(ctx, (state) => validSteps.some((step) => state.matches(step)));

  if (!render) {
    return null;
  }

  return <>{children}</>;
}
